import { Injectable } from '@angular/core';
/*
  Generated class for the StylizerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StylizerProvider {
	theme: {
		color1: string;
		color2: string;
		color3: string;
		color4: string;
		color5: string;
		color6: string;
		color7: string;
		color8: string;
	} = { color1: '', color2: '', color3: '', color4: '', color5: '', color6: '', color7: '', color8: '' };
    /***
        Wait a ICTAppCustomizing Object and a CSS as string:

        Format:
        let css = `.card-subtitle, .button-ios:not(.button-clear){
            background-color: $color1$;
            color: $@color1$;
            color: $color1%10$;
        }`;

        $color1$ = variable value from theme;
        $@color1$ = check variable color and returns white or black if the value is too light;
        $color1%10$ = set the variable color as a ligthness or darkness color;
    */
	public createCSS(front: any, css: string): void {
		this.theme.color1 = front.brandPrimaryColor ? '#' + front.brandPrimaryColor : null;
		this.theme.color2 = front.backgroundColor ? '#' + front.backgroundColor : null;
		this.theme.color3 = front.backgroundMenuTop ? '#' + front.backgroundMenuTop : null;
		this.theme.color4 = front.textColor ? '#' + front.textColor : null;
		this.theme.color5 = front.brandPrimaryColorDark ? '#' + front.brandPrimaryColorDark : null;
		this.theme.color6 = front.headingSidebarMenu ? '#' + front.headingSidebarMenu : null;
		this.theme.color7 = front.sidebarMenuColor ? '#' + front.sidebarMenuColor : null;
		this.theme.color8 = front.headingColor ? '#' + front.headingColor : null;
		let stylesObject = css;
		stylesObject = stylesObject.replace(/[$]+[\d\w]+[$]/g, (v) => {
			let value = v.replace(/[$]/g, '');
			return this.hexToRgb(this.theme[value]);
		});
		stylesObject = stylesObject.replace(/[$@]+[\d\w]+[$]/g, (v) => {
			let value = v.replace(/[$]/g, '').replace(/[@]/g, '');
			return this.hexToRgb(this.checkLightColor(this.theme[value]) ? '#000' : '#fff');
		});
		stylesObject = stylesObject.replace(/[$]+[\d\w]+[%][-\d]+[$]/g, (v) => {
			let value = v.replace(/[$]/g, '').split('%');
			let color = this.theme[value[0]];
			let percent = parseInt(value[1]) / 100;
			return this.hexToRgb(this.ColorLuminance(color, percent));
		});
		let styleTag = document.createElement('style');
		styleTag.id = "custom-styles";
		document.body.appendChild(styleTag);
		document.getElementById('custom-styles').innerHTML = stylesObject;
	}
	// private set
	private ColorLuminance(hex: string, lum: number): string {
		if (hex && lum) {
			// validate hex string
			hex = String(hex).replace(/[^0-9a-f]/gi, '');
			if (hex.length < 6) {
				hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
			}
			lum = lum || 0;
			// convert to decimal and change luminosity
			let rgb = "#", c, i;
			for (i = 0; i < 3; i++) {
				c = parseInt(hex.substr(i * 2, 2), 16);
				c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
				rgb += ("00" + c).substr(c.length);
			}
			return rgb;
		}
	}
	private checkLightColor(hex: string): boolean {
		if (hex) {
			hex.substring(1); // strip #
			let rgb = parseInt(hex, 16); // convert rrggbb to decimal
			let r = (rgb >> 16) & 0xff; // extract red
			let g = (rgb >> 8) & 0xff; // extract green
			let b = (rgb >> 0) & 0xff; // extract blue
			let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
			return luma > 40 ? true : false;
		}
	}
	private hexToRgb(hex: string): string {
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? (parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16)) : '';
	}
	public setFavicon(apiName: string, colorPrimary: string): void {
		let favicons = [
			{ rel: "apple-touch-icon", type: "", sizes: "57x57" },
			{ rel: "apple-touch-icon", type: "", sizes: "60x60" },
			{ rel: "apple-touch-icon", type: "", sizes: "72x72" },
			{ rel: "apple-touch-icon", type: "", sizes: "76x76" },
			{ rel: "apple-touch-icon", type: "", sizes: "114x114" },
			{ rel: "apple-touch-icon", type: "", sizes: "120x120" },
			{ rel: "apple-touch-icon", type: "", sizes: "144x144" },
			{ rel: "apple-touch-icon", type: "", sizes: "152x152" },
			{ rel: "apple-touch-icon", type: "", sizes: "180x180" },
			{ rel: "icon", type: "image/png", sizes: "192x192" },
			{ rel: "icon", type: "image/png", sizes: "32x32" },
			{ rel: "icon", type: "image/png", sizes: "96x96" },
			{ rel: "icon", type: "image/png", sizes: "16x16" }
		];
		let link;
		link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		let colorPositive = this.checkLightColor(colorPrimary) ? 'white' : 'black';
		link.href = 'https://dummyimage.com/128x128/' + colorPrimary + '/' + colorPositive + '.png&text=' + apiName.charAt(0).toUpperCase();
		document.getElementsByTagName('head')[0].appendChild(link);
		for (var index = 0; index < favicons.length; index++) {
			let favicon = favicons[index];
			let faviconLink = document.createElement('link');
			faviconLink.rel = favicon.rel;
			if (favicon.type != '')
				faviconLink.type = favicon.type;
			faviconLink.href = 'https://dummyimage.com/' + favicon.sizes + '/' + colorPrimary + '/' + colorPositive + '.png&text=' + apiName.charAt(0).toUpperCase();
			document.getElementsByTagName('head')[0].appendChild(faviconLink);
		}
		let themeColor = document.querySelector("meta[name='theme-color']");
		themeColor.setAttribute("content", '#' + colorPrimary);
	}

	public setGTM(gtmCode: string) {
		/*
			Original snippet (source: https://developers.google.com/tag-manager/quickstart):
			<!-- Google Tag Manager -->
			<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','GTM-XXXX');</script>
			<!-- End Google Tag Manager -->
		*/
		let gtmHead = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-XXXX');";
		gtmHead = gtmHead.replace("GTM-XXXX", gtmCode);
		let headScript = document.createElement('script');
		headScript.text = gtmHead;
		document.getElementsByTagName('head')[0].insertAdjacentElement('afterbegin', headScript);

		/*
			Original snippet (source: https://developers.google.com/tag-manager/quickstart):
			<!-- Google Tag Manager (noscript) -->
			<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-XXXX"
				height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
			<!-- End Google Tag Manager (noscript) -->
		*/
		let gtmSrc = "https://www.googletagmanager.com/ns.html?id=GTM-XXXX";
		gtmSrc = gtmSrc.replace("GTM-XXXX", gtmCode);
		let bodyNoScript = document.createElement('noscript');
		let bodyFrame = document.createElement('iframe');
		bodyFrame.src = gtmSrc;
		bodyFrame.height = "0";
		bodyFrame.width = "0";
		bodyFrame.style["display"] = "none";
		bodyFrame.style["visibility"] = "hidden";
		bodyNoScript.appendChild(bodyFrame);
		document.getElementsByTagName('body')[0].insertAdjacentElement('afterbegin', bodyNoScript);
	}
}



// WEBPACK FOOTER //
// ./src/providers/StylizerProvider.ts